import { requestBaseService } from './index'

export const postLeads = async (payload) => {
  const result = await requestBaseService({
    url: 'crm/ex/v1/lead',
    method: 'POST',
    data: payload,
  })

  return result
}

const Leads = {
  postLeads
}

export default Leads
